<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <compra-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CompraCrud from "./CompraCrud";
    export default {
        name: "Compra",
        components: {CompraCrud}
    }
</script>

<style scoped>

</style>

